import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyAbilitazioniService
 * Client API per le abilitazioni/titoli del personale (decreto GPG, porto
 * d'armi, idoneita' maneggio armi, tessera di riconoscimento, patenti...) e
 * relative scadenze, a livello lavoratore.
 */
export default class SafetyAbilitazioniService {
    /**
     * Catalogo tipi abilitazione, filtrato per settore.
     * @param {number} [id_lavoratore] se valorizzato, il settore e' derivato
     *        dall'azienda del lavoratore.
     * @param {string} [settore] settore singolo o CSV (sovrascrive la derivazione).
     */
    static getTipi = (id_lavoratore = "", settore = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/abilitazioni/tipi`;
            const payload = {};
            if (id_lavoratore) payload.id_lavoratore = id_lavoratore;
            if (settore) payload.settore = settore;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    /** Abilitazioni di un lavoratore. */
    static byLavoratore = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/abilitazioni/byLavoratore`;
            ApiService.postRequest(resolve, reject, url, { id_lavoratore });
        });
    };

    /** Crea un'abilitazione (FormData con eventuale file). */
    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/abilitazioni/create`;
        return ApiService.postFormData(url, formData);
    };

    /** Elimina (soft) un'abilitazione. */
    static deleteAbilitazione = (id_abilitazione) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/abilitazioni/delete`;
            ApiService.postRequest(resolve, reject, url, { id_abilitazione });
        });
    };

    /** Scarica il file di un'abilitazione. */
    static download = (id_abilitazione, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/abilitazioni/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_abilitazione, filename });
        });
    };
}
